import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-preprogram',
  templateUrl: './preprogram.component.html',
  styleUrls: ['./preprogram.component.css']
})
export class PreprogramComponent implements OnInit {

  constructor(
    private router : Router,
  ) { }

  ngOnInit() {
  }

  gotoHome(){
    this.router.navigateByUrl('/registerprogramgoals');
  }

}
